import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { CpmService } from '../../service/cpm.service'
import { AmChartsService } from '@amcharts/amcharts3-angular'
import { PdfChart } from '../../shared/pdfChart'
import { ActivatedRoute } from '@angular/router'
import 'rxjs/add/operator/map'
import { ExportPPTService } from 'app/service/export-ppt.service'
import { Subject } from 'rxjs/Subject'
import { DataTableDirective } from 'angular-datatables'

@Component({
  selector: 'app-ipo-exchange-in-5-year',
  templateUrl: './ipo-exchange-in-5-year.component.html',
  styleUrls: ['./ipo-exchange-in-5-year.component.scss']
})
export class IpoExchangeIn5YearComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  dtTrigger: Subject<any> = new Subject()
  textMark
  fundRaisedDataTableOptions: DataTables.Settings = {}
  form: FormGroup
  tradingDate
  round = 5
  ipoList5year
  ipoHeader = []
  chart3
  dataChart
  ipoCountry
  ipoMarket
  ipoFund
  totals = []
  dataShow
  getPrint
  showTable2
  dataTable
  asofdate
  dataProviderForIpoCap
  pdfChart: PdfChart = new PdfChart()
  currentItem = ''
  initTableFirstTime = false

  radios = [
    { value: 'C', des: 'Capital raised' },
    { value: 'M', des: 'Market cap' }
  ]
  constructor(
    private amCharts: AmChartsService,
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService,
    private pptService: ExportPPTService
  ) { }

  ngOnInit() {
    const { currentItem } = this.activatedRoute.snapshot.params // C,M
    currentItem === undefined
      ? (this.currentItem = 'C')
      : (this.currentItem = currentItem)
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.getPrint = print;
    this.pdfChart.setPdf(pdf)

    this.form = new FormGroup({
      radioValue: new FormControl(this.currentItem)
    })
    this.fundRaisedDataTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      order: [[7, 'asc']],
      language: {
        emptyTable: 'No information found'
      },
      columnDefs: [{ targets: 7, visible: false }]
    }

    this.onChangeData()
    $('table').removeClass('dataTable')
  }
  async onChangeData() {
    this.currentItem === 'C'
      ? (this.textMark = 'Capital raised')
      : (this.textMark = 'Market cap')
    if (this.initTableFirstTime) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
      })
    }
    await this.cpmService
      .getExchangeIpoin5year(this.form.get('radioValue').value, this.round)
      .then(obj => {
        this.ipoHeader = []
        this.asofdate = obj.asOfDate
        this.ipoHeader = obj.exchange.map(yearIpo => yearIpo.year)
        this.ipoCountry = obj.exchange.map(countryIpo => countryIpo.country)
        this.ipoMarket = obj.exchange.map(marketIpo => marketIpo.market)
        this.ipoFund = obj.exchange.map(fundIpo => fundIpo.fundRaised)

        this.ipoHeader = this.ipoHeader.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])

        this.ipoHeader.unshift('Exchanges')
        this.ipoHeader.push('Total')
        this.ipoCountry = this.ipoCountry.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])
        this.ipoMarket = this.ipoMarket.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])

        let list = []
        const listipoTable = []
        this.totals = this.ipoCountry.map(country => {
          list = []
          const Total = {}
          this.ipoHeader.map(year => {
            obj.exchange.map(ipolist => {
              if (country === ipolist.country && ipolist.year === year) {
                list.push(Math.trunc(ipolist.fundRaised))
                Total['market'] = ipolist.market
              }
            })
          })
          const tmp = [...list]
          tmp.unshift(Total['market'])
          tmp.unshift(country)

          listipoTable.push(tmp)
          Total['country'] = country
          Total['fundRaised'] = list.reduce((a, b) => a + b, 0)
          return Total
        })
        this.dataProviderForIpoCap = listipoTable.map(ipoObj => {
          const tmp = this.totals.find(
            objInner => objInner.country === ipoObj[0]
          )
          const ipoCap = {
            country: ipoObj[0],
            market: ipoObj[1],
            year1: ipoObj[2],
            year2: ipoObj[3],
            year3: ipoObj[4],
            year4: ipoObj[5],
            year5: ipoObj[6],
            total: tmp.fundRaised
          }
          return ipoCap
        })

        this.form.get('radioValue').value === 'C'
          ? this.markChartCapraised()
          : this.markChartCapraised()
      })

    if (!this.initTableFirstTime) {
      this.dtTrigger.next()
      this.initTableFirstTime = true
    } else {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        this.dtTrigger.next()
      })
    }
  }

  ngOnDestroy() {
    if (this.chart3 && this.chart3.legend && this.chart3.legend.destroy) {
      const tmp =
        this.chart3 != null ? this.amCharts.destroyChart(this.chart3) : null
    }
  }
  markChartCapraised() {
    this.dataChart = {
      type: 'serial',
      theme: 'none',
      fontFamily: 'browallia',
      fontSize: 18,
      categoryField: 'country',
      startDuration: 1,
      categoryAxis: {
        gridPosition: 'start'
      },
      graphs: [
        {
          balloonText:
            ' <b>[[country]]</b><br><span style="font-size:14px">[[title]]: <b>[[value]]</b></span>',
          fillAlphas: 1,
          id: 'AmGraph-1',
          title: this.ipoHeader[1],
          type: 'column',
          valueField: 'year1',
          labelText: '[[value]]',
          lineColor: '#5f6062',
          fillColors: '#5f6062',
          labelPosition: 'top',
          labelRotation: 270
        },
        {
          balloonText:
            ' <b>[[country]]</b><br><span style="font-size:14px">[[title]]: <b>[[value]]</b></span>',
          fillAlphas: 1,
          id: 'AmGraph-2',
          title: this.ipoHeader[2],
          type: 'column',
          valueField: 'year2',
          lineColor: '#D6D6DA',
          fillColors: '#D6D6DA',
          labelText: '[[value]]',
          labelPosition: 'top',
          labelRotation: 270
        },
        {
          balloonText:
            ' <b>[[country]]</b><br><span style="font-size:14px">[[title]]: <b>[[value]]</b></span>',
          fillAlphas: 1,
          id: 'AmGraph-3',
          title: this.ipoHeader[3],
          type: 'column',
          valueField: 'year3',
          lineColor: '#ffd200',
          fillColors: '#ffd200',
          labelText: '[[value]]',
          labelPosition: 'top',
          labelRotation: 270
        },
        {
          balloonText:
            ' <b>[[country]]</b><br><span style="font-size:14px">[[title]]: <b>[[value]]</b></span>',
          fillAlphas: 1,
          id: 'AmGraph-4',
          title: this.ipoHeader[4],
          type: 'column',
          valueField: 'year4',
          lineColor: '#fbb034',
          fillColors: '#fbb034',
          labelText: '[[value]]',
          labelPosition: 'top',
          labelRotation: 270
        },
        {
          balloonText:
            ' <b>[[country]]</b><br><span style="font-size:14px">[[title]]: <b>[[value]]</b></span>',
          fillAlphas: 1,
          id: 'AmGraph-5',
          title: this.ipoHeader[5],
          type: 'column',
          valueField: 'year5',
          lineColor: '#f98500',
          fillColors: '#f98500',
          labelText: '[[value]]',
          labelPosition: 'top',
          labelRotation: 270
        }
      ],
      valueAxes: [
        {
          id: 'ValueAxis-1',
          title: this.textMark + ' (M. USD)',
          gridThickness: '0'
        }
      ],
      legend: {
        enabled: true,
        position: 'bottom',
        useGraphSettings: true,
        align: 'center'
      },
      titles: [
        {
          id: 'Title-1',
          size: 20,
          text: 'Initial public offering in ASEAN exchanges in 5 years'
        }
      ],
      dataProvider: this.dataProviderForIpoCap
    }
    this.chart3 = this.amCharts.makeChart('chart3div', this.dataChart)
  }

  ppt() {
    this.pptService.pptIpoExchangeFiveYears(
      this.dataProviderForIpoCap,
      this.ipoHeader,
      this.textMark
    )
  }
  lastarray(arr: any) {
    return arr.slice(Math.max(arr.length - 5, 1))
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }
  numberToNoDecimal(num) {
    const numberWithCommas = x => {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
    return Number(parseFloat(num).toFixed(0))
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/ipo-exchange-in-5-year/ipo-exchange-in-5-year.component.ts